import { Organization } from '@protos/organization';
import { useAsync } from 'react-use';
import { useAdminApi } from './useAdminApi';

// Stable identity while loading: callers memoise on this list, and a fresh [] each
// render would invalidate their memo on every pass
const NO_ORGANIZATIONS: Organization[] = [];

// Every organization, for pickers that need to resolve a name to an id or offer the
// full roster. Grids use the paginated loader directly instead.
export function useOrganizationOptions() {
  const { apiClient } = useAdminApi();

  const state = useAsync(async () => {
    const organizations = await apiClient?.organizationsLoader().loadAllData();
    return organizations ?? NO_ORGANIZATIONS;
  }, [apiClient]);

  return {
    organizations: state.value ?? NO_ORGANIZATIONS,
    // useAdminApi resolves asynchronously, so useAsync reports loading:false for the
    // renders before apiClient exists. Callers that gate on this need "not ready yet".
    loading: state.loading || !apiClient,
    error: state.error,
  };
}
